import { InjectionToken } from '@angular/core';

export const NAVIGATOR_TOKEN = new InjectionToken<Navigator>(
  'Windows navigator object'
);
